import { Box, Checkbox, Chip, TableCell, TableRow, Tooltip } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../../../../constants';
import { ActionPerformed } from '../../../../shared_elements/components';
import LessMoreComp from '../../../../shared_elements/components/CustomLessMoreComp';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AuditPopover from '../../../../shared_elements/components/popover';


const PartyList = ({ toggleBulkOps,slug, item, onEdit,viewRevisonHistory,viewFileStatus,uploadedFileData,uploadFileProgressData, onDelete, onView, viewFile, bulk }) => {

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Parties Listing`, page_type: page_type, })
    }

    return (
        <TableRow >
            <TableCell className="table-actions-list">
                <Box className="table-icon-container">
                    <PermissionWrapper extraProps={{ application: 'lease_revamp', feature: 'party', operationType: ['D'] }}>
                        <Checkbox disableRipple style={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History">
                        <RestoreIcon className='revision-history' fontSize="small" color="primary" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['R'] }}>
                        <Tooltip title="View">
                            <VisibilityIcon fontSize="small" onClick={() => { onView(); handleItemClicked('ViewIcon') }} color="primary" sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['U'] }}>
                        <Tooltip title="Edit">
                            <EditIcon fontSize="small" color="primary" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['D'] }}>
                        <Tooltip title="Delete">
                            <DeleteIcon fontSize="small" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} color="error" sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "party", operationType: ['R'] }}>
                        {
                            item?.attachments?.length > 0 && (
                                <Tooltip title="Attached File(s)">
                                    <Box className="attachment-container">
                                        <AttachFileIcon fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                        <Box className="attachment-count">
                                            ({item.attachments.length})
                                        </Box>
                                    </Box>
                                </Tooltip>
                            )
                        }
                    </PermissionWrapper>
                   { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
                </Box>
            </TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.name || '--'}{item?.is_trustee ? <div><Tooltip title="Default Trustee" arrow ><Chip sx={{fontSize:"11px", height:"18px",cursor:'pointer'}} label="Default" size="small" variant="outlined" color='primary'  /></Tooltip></div> : null }</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.role_id?.name || '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><LessMoreComp name={item?.contact_address} lessMr='contact_address' /></TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.concerned_person_name || '--'}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.start_date ? moment(item.start_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.end_date ? moment(item.end_date).format(dateMonthYearDateFormat) : "--"}</TableCell>
            <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.country || '--'}</TableCell>
        </TableRow>
    );
};

export default PartyList;